export const myAccountPath = '/myaccount';
export const featureBoardPath = '/features-board';
export const USER_MY_ACCOUNT_EDIT = 'USER_MY_ACCOUNT_EDIT';
export const USER_MY_PASSWORD_EDIT = 'USER_MY_PASSWORD_EDIT';
export const USERS_API_ENDPOINT = 'users';
export const INCORRECT_PASSWORD = 'Incorrect password.';
export const NEW_PASSWORD = 'newPassword';
export const CURRENT_PASSWORD = 'currentPassword';
